import { LitElement, html, css } from 'lit';

export class RibbonFrame extends LitElement {
	static styles = css`
    :host {
      position: relative;
    }
    .frame {
      display: flex;
      align-items: center;
      gap: 10px;
      overflow: hidden;
      padding: 1rem;;
      height: auto;
      min-height: var(--card-height, 500px);
      scroll-snap-type:x mandatory;
		  scroll-behavior:smooth;
    }
    .items {
      display: flex;
      gap: 10px;
      overflow-x: auto;
      scroll-behavior: smooth;
      height: var(--card-height, 500px);
      padding: 1rem;
      justify-content: flex-start;
      align-items: center;
    }
    .button {
      cursor: pointer;
      background-color: var(--surface-hover);
      color: var(--on-surface);
      height: 200px;
      width: 40px;
      border: none;
      border-radius: 5px;
    }

    .button:hover {
      background-color: var(--color-gray-3);
    }

    /* Set the width of the items */
    ::slotted(studio-ui.components.galleries.v1.ribbon-item) {
      flex: 0 0 300px; /* Adjust width as needed */
      scroll-snap-align: start;
      scroll-snap-stop: always;
    }
  `;

	static properties = {
		items: { type: Array },
		currentIndex: { type: Number },
	};

	constructor() {
		super();
		this.items = [];
		this.currentIndex = 0;
	}

	next() {
		const itemsContainer = this.shadowRoot.querySelector('.items');
		itemsContainer.scrollBy({ left: itemsContainer.clientWidth, behavior: 'smooth' });
	}

	previous() {
		const itemsContainer = this.shadowRoot.querySelector('.items');
		itemsContainer.scrollBy({
			left: -itemsContainer.clientWidth,
			behavior: 'smooth',
		});
	}

	render() {
		return html`
      <div class="frame">
        <studio-button class="button" icon-only="true" style-type="clear" text-color="var(--color-primary)" icon="chevron-left" @click="${this.previous}">&laquo;</studio-button>
        <div class="items">
          <slot></slot> <!-- Slot for child elements -->
        </div>
        <studio-button class="button" icon-only="true" style-type="clear" text-color="var(--color-primary)" icon="chevron-right" @click="${this.next}">&raquo;</studio-button>
      </div>
    `;
	}
}

customElements.define(
	'studio-gallery-ribbon-frame',
	RibbonFrame
);
